import { apiClient } from '@/lib/api/client';
import { MESSAGES } from '@lib/constants/messages';
import type {
  GeolocationData,
  CreateAddressPayload,
  AddressResponse,
  CreateBranchOfficePayload,
  BranchOffice,
} from '../types/branchOffice.types';

export const branchOfficeService = {
  async getGeolocationByCoordinates(
    latitude: string,
    longitude: string
  ): Promise<GeolocationData> {
    const response = await apiClient.post('/geolocation/by-coordinates', {
      latitude,
      longitude,
    });

    console.log('Raw geolocation response:', response.data);

    // La API retorna un array, tomamos el primer elemento
    const data = Array.isArray(response.data) ? response.data[0] : response.data;

    console.log('Processed geolocation data:', data);

    return data;
  },

  async getFiscalCode(province: string, district: string, township: string): Promise<string> {
    const response = await apiClient.post('/geolocation/fiscal-code', {
      province,
      district,
      township,
    });
    console.log('Fiscal code response:', response.data);
    return response.data;
  },

  async createAddress(payload: CreateAddressPayload): Promise<AddressResponse> {
    const response = await apiClient.post('/companies/addresses', payload);
    return response.data;
  },

  async updateAddress(payload: CreateAddressPayload & { AddressId: string }): Promise<AddressResponse> {
    const response = await apiClient.put('/companies/addresses', payload);
    return response.data;
  },

  async createBranchOffice(payload: CreateBranchOfficePayload): Promise<BranchOffice> {
    const response = await apiClient.post('/companies/branch-offices', payload);
    const data = response.data;
    // Detect error bodies returned with HTTP 200 (Aludra pattern)
    if (data && (data.status === 'error' || data.Error || data.error === true)) {
      throw new Error(data.message || data.Message || data.Error || 'Error al crear la sucursal');
    }
    return data;
  },

  /**
   * Get branch office details from Aludra API
   * Returns full address details including IDs for province, district, township
   */
  async getBranchOfficeDetails(companyId: string, branchOfficeId: string): Promise<any> {
    console.log('🔍 Fetching branch office details:', { companyId, branchOfficeId });

    const response = await apiClient.post('/branchoffice/search', {
      CompanyId: companyId,
      BranchOfficeId: branchOfficeId,
      PageNumber: 1,
      PageSize: 10,
      IsActive: true,
    });

    console.log('📋 Branch office search response:', response.data);

    // API returns array in Data, take first element
    const branchDetails = response.data?.Data?.[0] || response.data?.[0];

    if (!branchDetails) {
      throw new Error(MESSAGES.BRANCH_OFFICE_NOT_FOUND);
    }

    console.log('✅ Branch office details found:', {
      Code: branchDetails.Code,
      Description: branchDetails.Description,
      AddressId: branchDetails.AddressId,
      Address_CountryId: branchDetails.Address_CountryId,
      Address_ProvinceId: branchDetails.Address_ProvinceId,
      Address_DistrictId: branchDetails.Address_DistrictId,
      Address_TownshipId: branchDetails.Address_TownshipId,
    });

    return branchDetails;
  },
};
